import type { StimaFotovoltaicoDTO } from '@/models/dto/fotovoltaico/stima-fotovoltaico-dto'
import type { PhotovoltaicEstimate } from '@/models/types/photovoltaic/photovoltaic-estimate'

function mapToPhotovoltaicEstimate(dto: StimaFotovoltaicoDTO): PhotovoltaicEstimate {
    return {
        id: dto.id,
        enabled: dto.abilitata,
        activationDate: dto.dataAttivazione ? dto.dataAttivazione.slice(0, 10) : undefined,
        gennaio: dto.gennaio ?? undefined,
        febbraio: dto.febbraio ?? undefined,
        marzo: dto.marzo ?? undefined,
        aprile: dto.aprile ?? undefined,
        maggio: dto.maggio ?? undefined,
        giugno: dto.giugno ?? undefined,
        luglio: dto.luglio ?? undefined,
        agosto: dto.agosto ?? undefined,
        settembre: dto.settembre ?? undefined,
        ottobre: dto.ottobre ?? undefined,
        novembre: dto.novembre ?? undefined,
        dicembre: dto.dicembre ?? undefined,
        fattoreAnno1: dto.fattoreAnno1 ?? undefined,
        fattoreAnno2: dto.fattoreAnno2 ?? undefined,
        fattoreAnno3: dto.fattoreAnno3 ?? undefined,
        fattoreAnno4: dto.fattoreAnno4 ?? undefined,
    }
}

function mapToStimaFotovoltaicoDTO(estimate: PhotovoltaicEstimate): StimaFotovoltaicoDTO {
    return {
        id: estimate.id,
        abilitata: estimate.enabled,
        dataAttivazione: estimate.activationDate ?? null,
        gennaio: estimate.gennaio ?? null,
        febbraio: estimate.febbraio ?? null,
        marzo: estimate.marzo ?? null,
        aprile: estimate.aprile ?? null,
        maggio: estimate.maggio ?? null,
        giugno: estimate.giugno ?? null,
        luglio: estimate.luglio ?? null,
        agosto: estimate.agosto ?? null,
        settembre: estimate.settembre ?? null,
        ottobre: estimate.ottobre ?? null,
        novembre: estimate.novembre ?? null,
        dicembre: estimate.dicembre ?? null,
        fattoreAnno1: estimate.fattoreAnno1 ?? null,
        fattoreAnno2: estimate.fattoreAnno2 ?? null,
        fattoreAnno3: estimate.fattoreAnno3 ?? null,
        fattoreAnno4: estimate.fattoreAnno4 ?? null,
    }
}

export { mapToPhotovoltaicEstimate, mapToStimaFotovoltaicoDTO }
